export default __webpack_public_path__ + "static/media/policyDoc.074deb25.pdf";